import React from 'react';
import styled from '@emotion/styled';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import P2 from '@base/P2/P2';
import { Spacings } from '@styles/index';
import Button from '@base/Button/Button';
import Image from '@base/Image';

interface IPreSubscriptionBannerProps {
  title: string;
  description: string;
  handleButtonClick: () => void;
}

const Wrapper = styled.div`
  padding: ${Spacings.SPACING_10B};
  background: rgb(8, 189, 128, 0.1);
  border-radius: ${Spacings.SPACING_2B};
  box-shadow: ${boxShadowGenerator()};
  display: flex;
  margin-bottom: ${Spacings.SPACING_10B};
  align-items: center;
`;

const InfoWrapper = styled.div`
  margin-left: ${Spacings.SPACING_4B};
  margin-right: ${Spacings.SPACING_23B};
`;

const StyP1 = styled(P1)`
  width: 342px;
  line-height: ${Spacings.SPACING_5B};
  margin-top: ${Spacings.SPACING_2B};
  color: var(--color-text-secondary);
`;

const StyP2 = styled(P2)`
  margin-top: ${Spacings.SPACING_3B};
  line-height: ${Spacings.SPACING_4B};
`;

const StyH3 = styled(H3)`
  line-height: ${Spacings.SPACING_7B};
`;

const PreSubscriptionBanner: React.FC<IPreSubscriptionBannerProps> = ({
  title,
  description,
  handleButtonClick
}) => {
  return (
    <Wrapper>
      <Image
        src="syllabus/plus-icon_new.svg"
        width="50px"
        height="52px"
        alt="plusicon"
      />
      <InfoWrapper>
        <StyH3>{title}</StyH3>
        <StyP1 color="var(--color-i-gray)">{description}</StyP1>
      </InfoWrapper>
      <Button
        // @ts-ignore
        label="Get subscription"
        onClick={handleButtonClick}
      />
    </Wrapper>
  );
};

export default PreSubscriptionBanner;
